export const ROUTES = {
  TEAM_PROJECTS: "/team/:id/projects",
  TEAMS: "/teams",
  DESIGNS: "/projects/:id/designs",
  DESIGNS_SHOW_NEW: "/projects/:id/newdesign",
  LOGIN_WITH_TOKEN: "/login/:token",
  LOGIN: "/login",
  SIGN_UP: "/signup",
  SIGN_UP_WITH_TOKEN: "/signup/:token",
  RESET_PASSWORD: "/resetpassword",
  UPDATE_PASSWORD: "/reset/:token",
  HOME: "/home",
  REFER_A_FRIEND: "/referralprogram",
  CART: "/cart",
  ORDERS: "/orders",
  ADMIN_PURCHASED_ORDERS: "/purchased/orders",
  ADMIN_TECHPACK_ORDER: "/techpack/order/:orderId",
  ADMIN_TECHPACK_PREORDER: "/techpack/preorder/:preorderId",
  ADMIN_PREORDER: "/purchased/preorder/:preorderId",
  ADMIN_VALIDATE_REFERRAL_CODE: "/validate/referralcode",
  ORDERS_SESSION: "/orders/session/:sessionId", //From checkout success of Stripe
  ORDERS_PREORDERS: "/orders/request/:preorderId", //From preorder
  SIZES: "/sizesadmin/:projectId",
  COLLECT_SIZE: "/sizes/:token",
  COLLECT_SIZE_SUCCESS: "/sizes/success/:token",
  STUDIO: "/design/:designId",
  STUDIO_PURCHASED_DESIGN:
    "/purchased/:orderType/:orderId/design/:designId/from/:historyFrom",
  JOIN: "/join/:token",
  SHIPPING_ADDRESS: "/cart/address",
};

/**
 * Artworks types (aligned with Specs artwork types)
 */
export const ARTWORK_TYPES = Object.freeze({
  TECHPACK_PRODUCTION: "techpackproduction",
});

/**
 * Asset behaves like (aligned with Specs behavesLike)
 */
export const BEHAVES_LIKE = Object.freeze({
  DETAILED_PRINT_TYPE: "detailedPrintType",
  EMBROIDERY_PATCH_TYPE: "embroideryPatchType",
  LEATHER_TAG_TYPE: "leatherTagType",
  SCREENPRINT_TYPE: "screenprintType",
  WOVEN_TAG_TYPE: "wovenTagType",
});
